import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';

class Reset extends Component {
    constructor(props) {
        super(props);
        this.state = {

            redirecionar: false
        }
    }

    componentDidMount = async () => {
        try {
            await axios.get(`${ambiente.dev.server}/reset`);
            this.setState({ redirecionar: true });
            this.props.exibirMensagem('yay', `Dados resetados com sucesso!`);
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        if (this.state.redirecionar) return <Redirect to="/" />;
        return (<div></div>);
    }
}

Reset.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Reset);



// WEBPACK FOOTER //
// ./src/components/home/Reset.js